import type { FailureRenderer } from './failureRenderer';

export const loadFailureRenderer = async (): Promise<FailureRenderer> => {
  const { failureRenderer } = await import(/* webpackChunkName: "3-render-failurerenderer" */ './failureRenderer');

  return failureRenderer;
};
